import { useEffect, useState } from 'react';
import axios from 'axios';

const API = 'https://ticobaterias.com/api';

export default function Informacion() {
  const [form, setForm] = useState({
    nombre_negocio:'', telefono:'', whatsapp:'', email:'',
    direccion:'', horario:'', lat:'', lng:'',
    facebook:'', instagram:'', tiktok:'', sobre_nosotros:''
  });
  const [guardado, setGuardado] = useState(false);
  const [id, setId] = useState<number|null>(null);
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    axios.get(`${API}/informacion/`).then(r => {
      setId(r.data.id);
      setForm({
        nombre_negocio: r.data.nombre_negocio||'',
        telefono: r.data.telefono||'',
        whatsapp: r.data.whatsapp||'',
        email: r.data.email||'',
        direccion: r.data.direccion||'',
        horario: r.data.horario||'',
        lat: r.data.lat||'',
        lng: r.data.lng||'',
        facebook: r.data.facebook||'',
        instagram: r.data.instagram||'',
        tiktok: r.data.tiktok||'',
        sobre_nosotros: r.data.sobre_nosotros||''
      });
    }).catch(() => {});
  }, []);

  const guardar = async (e: any) => {
    e.preventDefault();
    const data = {...form, lat: parseFloat(form.lat as any)||null, lng: parseFloat(form.lng as any)||null};
    if (id) await axios.put(`${API}/informacion/${id}`, data, { headers });
    else await axios.post(`${API}/informacion/`, data, { headers });
    setGuardado(true);
    setTimeout(() => setGuardado(false), 3000);
  };

  const campo = (label: string, key: string, placeholder?: string, type='text') => (
    <div>
      <label className="text-xs font-bold text-gray-500 tracking-wider block mb-1.5">{label}</label>
      <input type={type} value={(form as any)[key]} placeholder={placeholder}
        onChange={e => setForm({...form, [key]: e.target.value})}
        className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-azul"/>
    </div>
  );

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="font-bold text-2xl text-azul">Información del negocio</h1>
          <p className="text-gray-500 text-sm">Datos que aparecen en el sitio público</p>
        </div>
        {guardado && (
          <div className="bg-green-100 text-green-700 px-4 py-2 rounded-xl text-sm font-bold">
            ✅ Guardado exitosamente
          </div>
        )}
      </div>

      <form onSubmit={guardar} className="space-y-6">
        <div className="bg-white rounded-2xl border border-gray-100 p-6">
          <h2 className="font-bold text-azul mb-4">📋 Datos generales</h2>
          <div className="grid md:grid-cols-2 gap-4">
            {campo('NOMBRE DEL NEGOCIO', 'nombre_negocio', 'TicoBaterías')}
            {campo('TELÉFONO', 'telefono', '2270-5060')}
            {campo('WHATSAPP', 'whatsapp', '+506 8507-6464')}
            {campo('CORREO', 'email', 'ticobaterias.ventas@gmail.com')}
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-gray-100 p-6">
          <h2 className="font-bold text-azul mb-4">📍 Ubicación</h2>
          <div className="space-y-4">
            {campo('DIRECCIÓN', 'direccion', 'San José, Desamparados...')}
            {campo('HORARIO', 'horario', 'Lunes a Sábado 8am - 6pm')}
            <div className="grid grid-cols-2 gap-4">
              {campo('LATITUD GPS', 'lat', '9.8810556')}
              {campo('LONGITUD GPS', 'lng', '-84.0654078')}
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-gray-100 p-6">
          <h2 className="font-bold text-azul mb-4">📱 Redes sociales</h2>
          <div className="grid md:grid-cols-3 gap-4">
            {campo('FACEBOOK', 'facebook', 'https://facebook.com/...')}
            {campo('INSTAGRAM', 'instagram', 'https://instagram.com/...')}
            {campo('TIKTOK', 'tiktok', 'https://tiktok.com/...')}
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-gray-100 p-6">
          <h2 className="font-bold text-azul mb-4">ℹ️ Sobre nosotros</h2>
          <textarea value={form.sobre_nosotros} onChange={e => setForm({...form, sobre_nosotros: e.target.value})}
            placeholder="Descripción del negocio..."
            rows={4} className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-azul resize-none"/>
        </div>

        <button type="submit" className="w-full bg-azul text-white py-3 rounded-xl font-bold hover:bg-azul-dark transition-colors">
          💾 Guardar información
        </button>
      </form>
    </div>
  );
}
